export enum RouterUriComponents {
    LANDING_PAGE = 'landing-page',
    NOT_AUTHORIZED_PAGE = 'not-authorized',
    SEARCH_PAGE = 'customer-search',
    CUSTOMER_RULE = 'rules'
}

export enum RouterParams {
  SEARCH_KEY = 'searchKey'
}
